export { SALUTATION, FIRST_NAME, LAST_NAME, EMAIL, STREET, POSTAL_CODE, CITY, COUNTRY } from "../_sub-forms/customer-data/field-names";
export const CUSTOMER = "customer";
export { NEWSLETTER } from "../_sub-forms/newsletter-agreement/field-names";
export const NEWSLETTER_AGREEMENT = "newsletter";
export { AGB, PRIVACY } from "../_sub-forms/legal-agreement/field-names";
export const LEGAL_AGREEMENT = "legal";
